import React from "react";
import GameWindowHeader from "../GameWindowHeader";
import {CARGO_HEADER_COLORS} from "../GameStyleUI";
import GameWindowBg from "../GameWindowBg";
import {EMPTY_TRAIN_CAR_TYPE, GetTrainCarWeight, Variables} from "../../../gameplay/model/Balance";
import {CargoNames, CLIENT_NAMES} from "../../../constants/Constants";
import AddRemoveButtons from "../AddRemoveButtons";
import SortTrainCarWindow_UnloadToggle from "./SortTrainCarWindow_UnloadToggle";
import GameData from "../../../gameplay/model/GameData";
import RuntimeGameData from "../../../gameplay/model/RuntimeGameData";
import UtilsFunctions from "../../../utils/UtilsFunctions";

export default class SortCarTrainWindow_OrderCard extends React.Component {
    constructor(props) {
        super(props);
        this.trainCarValue = "";

        let clientsIndex = UtilsFunctions.getRoleNameIndex("Зам. по работе с клиентами");
        this.isClientMaster = UtilsFunctions.playerHasRole(clientsIndex);
    }

    componentDidMount() {
        let trainCarPack = this.props.isOrder ? GameData.CurrentGame.getOrderTrainCarById(this.props.trainCarsPack)
            : GameData.CurrentGame.getTrainCarById(this.props.trainCarsPack);
        if (!this.props.isOrder) {
            RuntimeGameData.CurrentGame.getSortTrainData().onStation[trainCarPack.id] = trainCarPack.isPreparing;
        } else {
            RuntimeGameData.CurrentGame.getSortTrainData().onLoad[trainCarPack.id] = trainCarPack.trainCarCount;
        }
        this.trainCarValue = RuntimeGameData.CurrentGame.getSortTrainData().onLoad[trainCarPack.id];
        this.forceUpdate();
        this.props.parent.forceUpdate();
    }

    calcWeight() {
        let trainCarPack = this.props.isOrder
          ? GameData.CurrentGame.getOrderTrainCarById(this.props.trainCarsPack)
          : GameData.CurrentGame.getTrainCarById(this.props.trainCarsPack);
        let count = this.props.isOrder
          ? RuntimeGameData.CurrentGame.getSortTrainData().onLoad[trainCarPack.id]
          : trainCarPack.trainCarCount;

        return (trainCarPack.type === EMPTY_TRAIN_CAR_TYPE
            ? Variables.trainCarWeight
            : GetTrainCarWeight(trainCarPack.type)
        ) * (count ?? 0);
    }

    isNormalInteger(str) {
        var n = Math.floor(Number(str));
        return n !== Infinity && String(n) === str && n >= 0;
    }

    render() {
        let mainStyle = {
            width: "163px",
            height: "248px",
        }
        let headerStyle = {
            display: "flex",
            width: "100%",
            justifyContent: "space-between"
        }
        let headerPaddings = {
            padding: "6px",
            width: "100%"
        }
        let TextLine1 = {
            lineHeight: "12px",
            fontSize: "10px",
            fontWeight: "normal",
            textTransform: "uppercase"
        }
        let TextLine2 = {
            lineHeight: "18px",
            fontSize: "14px",
            fontWeight: "bold",
            textTransform: "uppercase",
            textShadow: "0px 1px 1px rgba(0, 0, 0, 0.5)"
        }
        let textPaddings = {
            padding: "10px"
        }
        let delimeterStyle = {
            width: "100%",
            height: "1px",
            background: "rgba(3, 3, 3, 0.3)"
        }
        let trainCarPack = this.props.isOrder ? GameData.CurrentGame.getOrderTrainCarById(this.props.trainCarsPack)
            : GameData.CurrentGame.getTrainCarById(this.props.trainCarsPack);
        let station = this.props.station;
        let colors = CARGO_HEADER_COLORS(trainCarPack.type)
        let header = [];
        header.push(<div key={'header'} style={headerStyle}>
            <div style={{
                ...TextLine2,
                color: "white",
                textAlign: "left"
            }}>{CLIENT_NAMES[trainCarPack.client] || trainCarPack.client}</div>
            <div style={{...TextLine2, color: "white"}}>{trainCarPack.orderCode}</div>
        </div>);
        header = <div style={headerPaddings}>{header}</div>
        let content = [];
        let value = RuntimeGameData.CurrentGame.getSortTrainData().onLoad[trainCarPack.id];

        content.push(<div key={'type'} style={textPaddings}>
            <div style={{...TextLine1, textAlign: "center"}}>тип груза</div>
            <div style={{...TextLine2, textAlign: "center"}}>{CargoNames[trainCarPack.type]}</div>
        </div>);
        content.push(<div key={'tonnage'} style={textPaddings}>
            <div style={{...TextLine1, textAlign: "center"}}>ТОННАЖ</div>
            <div style={{...TextLine2, textAlign: "center"}}>{this.calcWeight()}</div>
        </div>);
        content.push(<div key={'delim'} style={delimeterStyle}/>);

        if (this.props.isOrder) {
            let max = GameData.CurrentGame.getMaxOrderTrainCarsToLoad(this.props.trainCarsPack);
            if (!Number.isFinite(max))
                max = station.trainCars;

            content.push(<AddRemoveButtons
                key={'buttons'}
                className={"order-popup"}
                asInputNumber={true}
                disabled={this.props.disabled}
                max={max}
                colors={colors}
                currentRuntime={value}
                onValueChanged={val => {
                    RuntimeGameData.CurrentGame.getSortTrainData().onLoad[trainCarPack.id] = val;
                    this.trainCarValue = val;
                    this.props.parent.forceUpdate();
                }}
                value={this.trainCarValue}
                isCanSell={this.isClientMaster && value > 0}
                isCanBuy={this.isClientMaster && station.trainCars - value > 0 && max > RuntimeGameData.CurrentGame.getSortTrainData().onLoad[trainCarPack.id]}
                style={{
                    marginTop: "20px",
                    paddingLeft: "25px",
                    paddingTop: "0"
                }}
            />);
        } else {
            // let order = GameData.CurrentGame.getOrderWithCode(trainCarPack.orderCode);
            // if(order){
            content.push(<SortTrainCarWindow_UnloadToggle key={'unl'}
                                                          isLoaded={RuntimeGameData.CurrentGame.getSortTrainData().onStation[trainCarPack.id]}/>);
            // } else {
            //     console.log(order);
            // }
        }
        return <div style={mainStyle} onClick={this.props.isOrder ? () => {
        } : () => {
            if (!this.isClientMaster)
                return;

            const order = GameData.CurrentGame.getOrderWithCode(trainCarPack.orderCode);
            if (!order) return;

            if (![order.fromId, order.toId].includes(station.id)) {
                alert(`Этот груз можно выгрузить только на станции ${GameData.CurrentGame.getStationByID(order.toId).name}!`);
                return;
            }

            RuntimeGameData.CurrentGame.getSortTrainData().onStation[trainCarPack.id] = !RuntimeGameData.CurrentGame.getSortTrainData().onStation[trainCarPack.id];
            this.props.parent.forceUpdate();
        }}>
            <GameWindowHeader width={153} height={40} colorStart={colors[0]} colorEnd={colors[1]}
                              customContent={header}/>
            <GameWindowBg width={153} height={this.props.isOrder ? 200 : 200} value={content}
            />
        </div>;
    }
}
